import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessengerRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			x: 4,
			y: 4,
			rx: 6,
			fill: "url(#messengerRegularPaint0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M16 9.088c3.893 0 6.912 2.856 6.912 6.707s-3.019 6.702-6.912 6.702c-.676 0-1.348-.089-2-.265-.123-.035-.255-.026-.372.026l-1.369.608a.6.6 0 0 1-.776-.49l-.038-1.228a.8.8 0 0 0-.19-.396A6.7 6.7 0 0 1 9.088 15.795C9.088 11.94 12.107 9.088 16 9.088Zm4.152 5.159c.194-.308-.187-.657-.475-.436l-2.186 1.657a.5.5 0 0 1-.594 0l-1.616-1.213a1.5 1.5 0 0 0-1.502.277l-2.03 3.221c-.194.308.187.658.476.438l2.182-1.659a.5.5 0 0 1 .502 0l1.615 1.213a1.5 1.5 0 0 0 1.498-.277l2.03-3.221Z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "messengerRegularPaint0",
			x1: 16,
			x2: 16,
			y1: 4,
			y2: 28,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00B2FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#006AFF"
			})]
		}) })
	]
});
export default SvgMessengerRegularIcon;
